import { render, staticRenderFns } from "./SectionA.vue?vue&type=template&id=13808cb6&scoped=true"
import script from "./SectionA.vue?vue&type=script&lang=js"
export * from "./SectionA.vue?vue&type=script&lang=js"
import style0 from "./SectionA.vue?vue&type=style&index=0&id=13808cb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13808cb6",
  null
  
)

export default component.exports